import { render, staticRenderFns } from "./BarChartHC.vue?vue&type=template&id=9d910b0a"
import script from "./BarChartHC.vue?vue&type=script&lang=js"
export * from "./BarChartHC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports